import React, { Component } from 'react';
import { Collapse } from 'react-collapse';
import PropTypes from 'prop-types';
import './ClientView.css';
import icons from '../../assets/icons';

export class ClientView extends Component {
  constructor(props) {
    super(props);
    this.state = { maximised: true, collapsible: false };
  }

  static get propTypes() {
    return {
      client: PropTypes.object.isRequired,
    };
  }

  // getDerivedStateFromProps(props, state) {
  //   if(props.collapsible === true) {
  //     return {  maximised: false }
  //   }
  // }

  componentWillReceiveProps(newProps) {
    let maximised = true;
    let collapsible = false;
    if (newProps.collapsible !== undefined && newProps.collapsible === true) {
      maximised = false;
      collapsible = true;
    }

    this.setState({ maximised, collapsible });
  }

  toggleView() {
    const { collapsible } = this.state;
    this.setState({ maximised: !this.state.maximised, collapsible });
  }

  render() {
    const { client } = this.props;
    const { maximised, collapsible } = this.state;
    if (!client) return null;

    const expandCollapseImg = maximised ? icons.upArrow : icons.downArrow;
    if (client.ClientName) {
      return (<span className="ClientView">
        <span className="row">
          <span className="name">{client.ClientName}</span>
        </span>
        <span className="row multiple-values">
          <span className="additional">{client.AdditionalName}&nbsp;</span>
          <span className="additional">{client.MifidClassification}&nbsp;</span>
        </span>
        <span className="row multiple-values">
          <span className="gcid value-wrapper"><span className="label">GCID:</span><span className="value">{client.GlobalClientId || '-'}</span></span>
          <span className="bloomberg value-wrapper"><span className="label">Bloomberg:</span><span className="value">{formatCodes(client.Bloombergs)}</span> </span>
        </span>
        <div className="expand-container">
          <Collapse isOpened={maximised}>
            <span className="row multiple-values">
              <span className="ppq value-wrapper"><span className="label">PPQ:</span><span className="value">{formatCodes(client.PPQs)}</span></span>
              <span className="kondor value-wrapper"><span className="label">Kondor:</span><span className="value">{formatCodes(client.Kondors)}</span></span>
            </span>
            <span className="row multiple-values">
              <span className="isb value-wrapper"><span className="label">ISB:</span><span className="value">{formatCodes(client.ISBs)}</span></span>
              <span className="omr value-wrapper"><span className="label">OMR:</span><span className="value">{formatCodes(client.OMRs)}</span></span>
            </span>
          </Collapse>
          {collapsible && <span><img className="expand-button" role="none" onClick={() => this.toggleView()} src={expandCollapseImg} alt="expand/collapse" /></span>}
        </div>
      </span>);
    }
    return (
      <span className="ClientView">
        <span className="name">Client ID: {client.OrbClientId}</span>
      </span>
    );
  }
}

const formatCodes = (codes) => {
  if (!codes) {
    return '-';
  }
  if (!Array.isArray(codes)) {
    return codes;
  }
  const formattedCodes = codes.map(codeObj => codeObj.Alias);
  const codeString = formattedCodes.join(', ');
  return codeString;
};

export function clientRenderer(client) {
  return <ClientView client={client} />;
}
export function clientRendererCollapsible(client) {
  return <ClientView client={client} collapsible />;
}



// WEBPACK FOOTER //
// ./src/recordDetail/client/ClientView.js